<template>
<div id="user">
  <topWrapper />
    <router-view/>
  <bottomWrapper />
</div>
</template>

<script>
// @ is an alias to /src
import topWrapper from "@/views/user/component/top.vue";
import bottomWrapper from "@/views/user/component/bottom.vue";
export default {
  name: "user-layout",
  components: {
    topWrapper,
    bottomWrapper
  },
  data() {
    return {
    };
  },
  methods: {},
  mounted() {
    // console.log(pub.cdnUrl);
  }
};
</script>
<style lang="scss">
</style>
